import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Button.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    _vm._g(
      {
        ref: "button",
        attrs: {
          type: "button",
          appearance: _vm.appearance,
          disabled: _vm.isDisabled,
          selected: _vm.isSelected,
          loading: _vm.isLoading,
          spacing: _vm.spacing
        }
      },
      _vm.listeners
    ),
    [
      _c(
        "span",
        {
          staticClass: "wrapper",
          attrs: { tabindex: "-1", "icon-is-only-child": _vm.iconIsOnlyChild }
        },
        [
          !_vm.isLoading ? _vm._t("icon-before") : _vm._e(),
          _vm._v(" "),
          this.$slots.default
            ? _c(
                "span",
                { ref: "label", staticClass: "label" },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading ? _vm._t("icon-after") : _vm._e(),
          _vm._v(" "),
          _vm.isLoading
            ? _c("Spinner", {
                attrs: { size: _vm.spacing === "default" ? "small" : "icon" }
              })
            : _vm._e()
        ],
        2
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-39fd64cc";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Button/Button.vue.js